import React, { FC } from 'react';
import { useTranslation } from 'react-i18next';
import Button from '../UI/Buttons/buttons';
import { useIsShowMCreate } from '../../domains/client/create/hooks';
import css from './styles.module.scss';
import AccessUserRight from '../AccessUserRight';
import { useStorageAgenciesTabs } from '../../domains/storage/model/selectors';
import { ElementsNoneImages } from './Images';

type TAgenciesNoneProps = {
  /* От этого параметра меняетсятся текст */
  search?: boolean | null;
};

const AgenciesNone: FC<TAgenciesNoneProps> = ({ search }) => {
  const { t } = useTranslation();
  const status = useStorageAgenciesTabs();
  const isShowMCreate = useIsShowMCreate(true);

  return (
    <div className={css.empty}>
      <div className={css.img}>
        {search ? (
          <img
            src={ElementsNoneImages.no_search}
            alt={ElementsNoneImages.no_search}
          />
        ) : (
          <>
            {status === 'LAUNCHED' && (
              <img
                src={ElementsNoneImages.agencies_empty_active}
                alt={ElementsNoneImages.agencies_empty_active}
              />
            )}
            {status === 'STOPPED' && (
              <img
                src={ElementsNoneImages.agencies_empty_stop}
                alt={ElementsNoneImages.agencies_empty_stop}
              />
            )}
            {status === 'ARCHIVE' && (
              <img
                src={ElementsNoneImages.agencies_empty_arhiv}
                alt={ElementsNoneImages.agencies_empty_arhiv}
              />
            )}
            {status === 'DELETED' && (
              <img
                src={ElementsNoneImages.agencies_empty_del}
                alt={ElementsNoneImages.agencies_empty_del}
              />
            )}
            {status === null && (
              <img
                src={ElementsNoneImages.general}
                alt={ElementsNoneImages.general}
              />
            )}
          </>
        )}
      </div>
      {search ? (
        <div className={css.search}>
          <div className={css.header}>{`${t('search_none.none_1')}`}</div>
          <div className={css.text}>
            <span>{`${t('search_none.none_2')}`}</span>
            <span>{`${t('search_none.none_3')}`}</span>
          </div>
        </div>
      ) : (
        <div className={css.title}>
          {status === 'LAUNCHED' && t('agencies_page.agency_none.empty1')}
          {status === 'STOPPED' && t('agencies_page.agency_none.empty2')}
          {status === 'ARCHIVE' && t('agencies_page.agency_none.empty3')}
          {status === 'DELETED' && t('agencies_page.agency_none.empty4')}
          {status === null && (
            <>
              <div>{t('agencies_page.agency_none.empty5')}</div>
              <span  style={{
                    fontWeight: 400,
                  }}>{t('agencies_page.agency_none.empty6')}</span>
              <div className={css.actions}>
                <AccessUserRight>
                  {(props) => (
                    <Button
                      title={t('agencies_page.create_btn')}
                      buttonAttributes={{
                        className: css.link,
                        onClick: isShowMCreate,
                        disabled: props.isDisable,
                      }}
                    />
                  )}
                </AccessUserRight>
              </div>
            </>
          )}
        </div>
      )}
    </div>
  );
};
export default AgenciesNone;
